import { ScheduleZoom } from './types'

export const DEFAULT_HEADER_COLUMN_WIDTH = 168

export const COLUMN_WIDTH: Record<ScheduleZoom, number> = {
  week: 195,
  month: 44,
}

export const composableZIndex = {
  head: 4,
  cellTitle: 2,
  headCell: 1,
  headCellTitle: 2,
  shiftError: 1,
  newShiftRow: 3,
}

export const HEADER_HEIGHT = 44
